import Tone from 'tone'

export default([
  {
    id: 0,
    name: 'Bass',
    playing: false,
    currentTrack: 0,
    trackToPlay: -1,
    tracks: [
      {
        id: 0,
        name: 'Electric',
        track: new Tone.Player({
          url: './InstrumentTracks/Bass1.electric.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 1,
        name: 'Jamaican',
        track: new Tone.Player({
          url: './InstrumentTracks/Bass2.jamaica.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 2,
        name: 'Mix',
        track: new Tone.Player({
          url: './InstrumentTracks/Bass3.mix.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 3,
        name: 'Uptempo',
        track: new Tone.Player({
          url: './InstrumentTracks/Bass4.uptempo.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      }
    ]
  }, 
  {
    id: 1,
    name: 'Drums',
    playing: false,
    currentTrack: 0,
    trackToPlay: -1,
    tracks: [
      {
        id: 0,
        name: 'African',
        track: new Tone.Player({
          url: './InstrumentTracks/Drums1.africa.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 1,
        name: 'Tribal',
        track: new Tone.Player({
          url: './InstrumentTracks/Drums2.tribal.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 2,
        name: 'Jazz',
        track: new Tone.Player({
          url: './InstrumentTracks/Drums3.jazz.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 3,
        name: 'Rhythm',
        track: new Tone.Player({
          url: './InstrumentTracks/Drums4.rhythm.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      }
    ]
  },
  {
    id: 2,
    name: 'HipHop',
    playing: false,
    currentTrack: 0,
    trackToPlay: -1,
    tracks: [
      {
        id: 0,
        name: 'Urban',
        track: new Tone.Player({
          url: './InstrumentTracks/Hiphop1.urban.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 1,
        name: 'Funk',
        track: new Tone.Player({
          url: './InstrumentTracks/Hiphop2.funk.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 2,
        name: 'On Time',
        track: new Tone.Player({
          url: './InstrumentTracks/Hiphop3.ontime.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 3,
        name: 'Bronx',
        track: new Tone.Player({
          url: './InstrumentTracks/Hiphop4.bronx.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      }
    ]
  },
  {
    id: 3,
    name: 'Piano',
    playing: false,
    currentTrack: 0,
    trackToPlay: -1,
    tracks: [
      {
        id: 0,
        name: 'Happy',
        track: new Tone.Player({
          url: './InstrumentTracks/Piano1.happy.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 1,
        name: 'Country',
        track: new Tone.Player({
          url: './InstrumentTracks/Piano2.country.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 2,
        name: 'Fresh',
        track: new Tone.Player({
          url: './InstrumentTracks/Piano3.fresh.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
      {
        id: 3,
        name: 'Reggae',
        track: new Tone.Player({
          url: './InstrumentTracks/Piano4.reggae.mp3',
          volume: -6,
          fadeIn: 0.1,
          fadeOut: 0.1,
          loop: true
        }).sync().toMaster(),
        selected: false,
      },
    ]
  }
])


// WEBPACK FOOTER //
// ./src/Instrument/instrumentData.js